import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'core/api';
import { subjectFromObs } from 'core/rx-js';
import { LoaderService } from 'core/services';
import { DsgDeepTranslationKey } from 'projects/designer/src/app/pipes/translate.pipe';
import { combineLatest, filter, map, switchMap, take } from 'rxjs';
import { ActorAuthChecklistService } from '../actor-auth.checklist/actor-auth.checklist.service';
import { IActorSplugDialogData } from '../actor-splug-info/actor-splug-info.component';
import { ActorSplugInfoService } from '../actor-splug-info/actor-splug-info.service';

@Injectable()
export class ActorConfigService {

  get actor() {
    return this._data.actor
  }

  readonly externalSubject = subjectFromObs({
    observable: this._apiService.get<{ name: 'EXTERNAL' | 'INTERNAL' }>('users/type/getByActivityId', { activityId: this.actor.activityId })
      .pipe(
        take(1),
        map(({ name }) => name === 'EXTERNAL')
      )
    ,
    initialValue: false
  })

  private readonly _actorSplugInfoDialogService = this._data.actorSplugInfoDialogService;
  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: IActorSplugDialogData,
    private readonly _actorSplugInfoService: ActorSplugInfoService,
    private readonly _actorAuthChecklistService: ActorAuthChecklistService,
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>,
    private readonly _apiService: ApiService,
  ) {

  }

  validate() {
    const id = this._loaderService.show({ key: 'splug.validate' })

    return this._actorSplugInfoService.validate()
      .pipe(this._loaderService.disposeLoader(id))

  }

  validateAndSave() {

    const id = this._loaderService.show({ key: 'splug.validate' })

    this._actorSplugInfoService.validate()
      .pipe(
        this._loaderService.disposeLoader(id),
        take(1),
        filter((validationResult) => (validationResult?.isValid || validationResult === null) && this._actorAuthChecklistService?.isValid),
        switchMap((validationResult) => {

          if (!validationResult?.actorSplugsWithParams) {
            return this._actorAuthChecklistService.save(this.actor.activityId);
          }

          return combineLatest([
            this._actorSplugInfoService.save(validationResult.actorSplugsWithParams),
            this._actorAuthChecklistService.save(this.actor.activityId)
          ])
        }),
        take(1)
      )
      .subscribe(() => {
        this._actorSplugInfoDialogService.close();
      })



  }
}
